import React from 'react';
import { Flex, Grid, View, useTheme } from '@aws-amplify/ui-react';
import { useLabelOptions } from 'contexts/labelOptionsContext';
import AsideCarousel from 'components/AsideCarousel';
import AsideWL from 'components/AsideWL';
import Footer from 'components/Authenticator/components/Footer';

const Layout = ({ children }) => {
  const { tokens } = useTheme();
  const { labelOptions } = useLabelOptions();

  return (
    <Grid
      templateColumns={{
        xl: '650px 1fr',
        large: '1fr 2fr',
        base: '0 1fr',
      }}
      minHeight="100vh"
      width="100%"
      className="girdLayout"
      style={{
        background: labelOptions.isWL ? '#F7FAFD' : 'linear-gradient(180deg, #0C71E7 0%, #00D487 100%)',
      }}
    >
      <View
        height={{
          base: '0px',
          large: '100%',
        }}
      >
        {labelOptions.isWL ? <AsideWL /> : <AsideCarousel />}
      </View>

      <Flex padding={tokens.space.small} direction="column" alignItems="center" justifyContent="center" gap="0">
        <View
          borderRadius={tokens.radii.large}
          backgroundColor={tokens.colors.background.primary}
          maxWidth={tokens.components.authenticator.container.widthMax}
          width="100%"
          boxShadow={tokens.shadows.medium}
          textAlign="center"
          position="relative"
        >
          {children}
        </View>
        <Footer />
      </Flex>
    </Grid>
  );
};

export default Layout;
